import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Company } from "./company";
import { Business } from "../../business/_types/business";
import { CostCenter } from "../../costs-center/_types/costCenter";
import { Integration } from "./integration";

export class Contract extends Resource {
    public override type = 'contracts';

    @prop()
    public companyId!: string;

    @propObject(Company)
    public company!: Company;
    @prop()
    @required()
    public name!: string;
    @prop()
    public code!: string;
    @prop()
    @required()
    public startDate!: Date;
    @prop()
    public endDate!: Date;
    @prop()
    public case_prefix!: string;
    @prop()
    @required()
    public billingCompanyId!: string;
    @propObject(Business)
    public business!: Business;
    @prop()
    public billingCompanyBankAccountId!: string;
    @prop()
    public paymentMethodId!: string;
    @prop()
    //canal por el que se envia el "Sigue tu expediente" al crear un expediente: None, SMS o Whatsapp
    public sendCaseTracking: string = 'None';
    @prop()
    public sendVideoReportFlow: boolean = false;
    @prop()
    public profitMinPercent: number = 5;
    @prop()
    public profitDesiredPercent: number = 20;
    @prop()
    public budgeDiscount: number = 0;
    @prop()
    public invoiceDiscount: number = 0;
    @prop()
    public notes!: string;
    @prop()
    public invoiceMode: string = "invoice";
    @prop()
    public costCenterId!: string;
    @propObject(CostCenter)
    public costCenter!: CostCenter;
    @prop()
    public invoiceRetentionPercent: number = 0;
    @prop()
    public invoiceRetentionDays: number = 0;
    @prop()
    public paymentDuedateDays: number = 0;
    
    @prop()
    public integrationId!: string;

    @propObject(Integration)
    public integration!: Integration;

    @prop()
    public integrationConfig!: string;

    @prop()
    public responsibleUserId!: string;
    @prop()
    public secondResponsibleUserId!: string;

    @prop()
    public jobCompanyDiscountPercent!: number;

    @prop()
    public jobGuardCompanyIncrementPercent!: number;

    @prop()
    public allowBillIfNotClosed: boolean = true;

    @prop()
    public allowPartialBill: boolean = true;
    
    @prop()
    public contactName!: string;
    @prop()
    public contactPhone1!: string;
    @prop()
    public contactEmail!: string;
    @prop()
    public urgentPlusReminder: boolean = false;
    @prop()
    public enableCaseNumberGenerate: boolean = false;

    @prop()
    public target: string = "Client";

}